export default {
  title: 'Kom i gang',
  description: 'For at indlæse denne side skal du først gennemføre Kom i gang-guiden',
  button: 'Kom i gang',
};
